import { render } from "./DropdownActions.vue?vue&type=template&id=95a72526"
import script from "./DropdownActions.vue?vue&type=script&lang=ts"
export * from "./DropdownActions.vue?vue&type=script&lang=ts"
script.render = render

export default script